import React from "react";
import "./BucketElevatorChain.css";
import buckimg from "./bucket.jpg";

const BucketElevatorChain = () => {
  return (
    <div className="main-bucket">
      <div className="second-bucket">
        <div className="bucket">
          <p>Bucket Elevator Chain</p>
          <div>
            <p className="buck2">
              Swajit Engineering Pvt.Ltd.> Bucket Elevator Chain
            </p>
          </div>
        </div>
        <div className="elevator">
          <h2 className="best3">
            Why would you choose Bucket Elevator Chain Manufacturers In India?
          </h2>
          <p>
            We at Swajit engineering Pvt ltd are leading one of the Bucket
            Elevator Chain Manufacturers in Aurangabad, Maharashtra India. We
            provide a wide range of bucket elevator chains at affordable rates
            to diversified applications. Our offered range of chains is designed
            with the highest quality materials in compliance to meet
            international standards. We keep regularly updating the bucket
            elevator chains in order to implement multiple tasks.
          </p>

          <div className="buck-chain">
            <img src={buckimg} alt="img"></img>

            <div className="buck-chain1">
              <div className="buck-chain2">
                <p className="">
                  With the assistance of our expert team, we have been
                  manufacturing high-grade bucket elevator lift chains for
                  worldwide industries for a longer time. Having the <b>best Bucket
                  Elevator Chain manufacturer in India</b>, we help the customers to
                  increase the production level of their projects and
                  applications. All these bucket elevator chains are designed in
                  compliance with international norms and standards. Therefore,
                  our products are widely accepted by the customers from the
                  whole market.
                  <h3> What is the use of a bucket elevator chain?</h3>
                   A bucket elevator or grain leg is used in many industries to
                  elevate a variety of bulk materials from light to heavy
                  materials. Bucket Elevator System designed with chains and
                  various kinds of attachments that perform efficiently.
                </p>
              </div>
            </div>
          </div>

          <div className="buck-chain3">
            <h3>
              Where do our bucket elevator chains are used? What are its
              benefits?
            </h3>
            <p>
              Owing to its quality features and excellent performance, our
              bucket elevator chains are widely used in the industries such as
              cement, packaging, food processing, chemical, pharmaceutical,
              plastic injection, construction field, mining, etc. The bucket
              elevator chains are available in centrifugal, continuous as well
              as positive discharge elevators. They are highly durable in
              nature, reliable performance, corrosion-resistant, and can carry
              heavy-strength material.
            </p>
            <p>Contact us on 9922941689 or Email marketing@swajit.com.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BucketElevatorChain;
